import React from 'react';
import AppLayout from '../../components/AppLayout';
import { Row, Col, Card, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  FileDoneOutlined,
  FileTextOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';

const ManufacturingScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <h2 style={{ marginBottom: '1rem' }}>Manufacturing Dashboard</h2>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} hoverable onClick={() => navigate('/manufacturing/work-order')} style={{ borderRadius: 12 }}>
            <Statistic title="Work Orders" value={42} prefix={<FileDoneOutlined />} />
            <p>Total created and tracked here.</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} hoverable onClick={() => navigate('/manufacturing/job-cards')} style={{ borderRadius: 12 }}>
            <Statistic title="Job Cards" value={36} prefix={<FileTextOutlined />} />
            <p>Tasks assigned to technicians.</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} hoverable onClick={() => navigate('/manufacturing/boms')} style={{ borderRadius: 12 }}>
            <Statistic title="BOMs" value={15} prefix={<SnippetsOutlined />} />
            <p>Materials needed to build products.</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} hoverable style={{ borderRadius: 12 }} onClick={() => navigate('/manufacturing/downtime-entries')}>
            <Statistic title="Downtime Entries" value={5} prefix={<SnippetsOutlined />} />
            <p>Track delays or maintenance logs.</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} hoverable style={{ borderRadius: 12 }} onClick={() => navigate('/manufacturing/stock-entries')}>
            <Statistic title="Stock Entries" value={50} prefix={<SnippetsOutlined />} />
            <p>Material movements for production.</p>
          </Card>
        </Col>
      </Row>
    </AppLayout>
  );
};

export default ManufacturingScreen;
